import React, {useContext} from 'react';
import {NavLink} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {AuthContext} from '../../auth/AuthContext';
import {logoutAction} from "../../redux/toolkit/loginSlice";
import {
    People,
    Person,
    Collection,
    Power,
    Bezier,
    MenuDown,
    CashCoin,
    WindowDock
} from 'react-bootstrap-icons';
import c from './dashboard.module.css';

// One row each. They were six near-identical blocks of JSX, which is why the
// chevrons and the missing active state had to be fixed in six places.
const NAV_ITEMS = [
    {to: '/available',           label: 'Available Tests',      Icon: Collection},
    {to: '/performed',           label: 'Performed Tests',      Icon: MenuDown},
    {to: '/newTest',             label: 'New Test',             Icon: Bezier},
    {to: '/personalInformation', label: 'Personal Information', Icon: People},
    {to: '/invoices',            label: 'Payments',             Icon: CashCoin},
    {to: '/termsOfUse',          label: 'Terms and Conditions', Icon: WindowDock},
];

const SideBar = () => {

    const dispatch = useDispatch();
    const auth = useContext(AuthContext);
    const logOut = () => {
        dispatch(logoutAction())
        auth.logOut();
    }

    return (
        <div className={c.sideBarDashboard}>
            <div className={c.fixedContent}>

                <div className={c.sideBarUserContent}>
                    <div className={c.sideBarItem}>
                        <div className={c.sideBarItemIcon}><Person size={28}/></div>
                        <div className={c.sideBarItemTitle} title='Account'>
                            {auth?.account_name}
                        </div>
                        <div className={c.logoutButton} onClick={logOut} title='Logout'>
                            <Power size={25}/>
                        </div>
                    </div>
                </div>

                <nav className={c.sideBarOptions}>
                    {NAV_ITEMS.map(({to, label, Icon}) => (
                        // The chevrons that used to sit on the right of every
                        // row promised a submenu none of them has.
                        <NavLink key={to} to={to} title={label}>
                            {({isActive}) => (
                                <div className={`${c.sideBarOptionsItem}${isActive ? ' ' + c.sideBarOptionsItemActive : ''}`}>
                                    <span className={c.sideBarOptionsIcon}><Icon size={28}/></span>
                                    <span className={c.sideBarOptionsTitle}>{label}</span>
                                </div>
                            )}
                        </NavLink>
                    ))}
                </nav>
                <div className={c.sideBarBottomLogo}>
                    <div className={c.starImageContainer}>
                        <div className={c.starWithText}>
                            <img className={c.starImage} src="/img/start.png" alt="star"/>
                            <div className={c.starTextOverlay}>
                                <div className={c.challengeText}>Tox24 Challenge</div>
                                <div className={c.winnerText}>2nd Place Winner</div>
                            </div>
                        </div>
                        <div className={c.starWithText}>
                            <img className={c.starImage} src="/img/start.png" alt="star"/>
                            <div className={c.starTextOverlay}>
                                <div className={c.challengeText}>EUOS25 Challenge</div>
                                <div className={c.winnerText}>Group Winner</div>
                            </div>
                        </div>
                    </div>
                    <a rel="noreferrer" href='https://www.toxometris.ai/' target='_blank'>
                        <img className={c.imageLogo} src="/img/Logo2.png" alt="logo"/>
                    </a>
                    <span style={{color: 'silver', letterSpacing: '0.09rem'}}>support@toxometris.ai</span>
                </div>
            </div>
        </div>
    );
};

export default SideBar;
